import { ToggleNotesHeaderCell } from "../../../../../../components/table";
import { useApplicationReviewTableState } from "./_store";

export const ApplicationReviewNotesHeader = () => {    

  const { hasNotes, toggleAllNotes, showAllNotes } = useApplicationReviewTableState(state => state);  
    
  return (    
    <ToggleNotesHeaderCell hasNotes={hasNotes} show={showAllNotes} toggleNotes={toggleAllNotes} />
  )
}
